import type { ComponentProps } from 'react';

import { CheckboxGroup as UadCheckboxGroup } from '@iconik-io/uad';

import { useFieldContext } from '../app_form_context';
import { getFieldErrorMessage } from '../get_field_error_message';

type UadCheckboxGroupProps = ComponentProps<typeof UadCheckboxGroup>;

export type CheckboxFieldGroupProps = Omit<
  UadCheckboxGroupProps,
  'name' | 'value' | 'onChange' | 'onBlur' | 'isInvalid' | 'errorMessage'
>;

export function CheckboxFieldGroup(props: CheckboxFieldGroupProps) {
  const field = useFieldContext<string[]>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <UadCheckboxGroup
      value={field.state.value}
      onChange={(value) => {
        field.setValue(value);
      }}
      onBlur={field.handleBlur}
      isInvalid={isInvalid}
      errorMessage={
        isInvalid ? getFieldErrorMessage(field.state.meta.errors) : undefined
      }
      {...props}
    />
  );
}
